import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterDataArray'
})
export class FilterDataPipe implements PipeTransform {
  transform(array: Array<any>, type: string, applyFilterKey: any, section: string = ""): Array<any> {
    let finalFilterArray: Array<any> = [];
    if (type === 'beatFilter') {
      if (applyFilterKey) {
        finalFilterArray = array;
        let filter: any = applyFilterKey?.filter;
         if (filter.hasOwnProperty('categories')) {
          let categories: any = filter.categories;
          finalFilterArray = finalFilterArray.filter((item: any) => categories.includes(item.category));
         }

         if (filter.hasOwnProperty('moods')) {
          let moodsList: any = filter.moods;
          finalFilterArray = finalFilterArray.filter((item: any) => {
            let moodData = item.mood;
            if (moodData && moodData.length > 0) {
              let filterList: any  = moodData.filter((moodObj: any) => moodsList.includes(moodObj))
              if (filterList &&  filterList.length > 0) {
                return item;
              }
            }
          });
         }
         if (filter.hasOwnProperty('tempo')) {
          let tempo: any = filter.tempo;
          finalFilterArray = finalFilterArray.filter((item: any) => item.tempo >= tempo.min && item.tempo <= tempo.max);
         }
         if (filter.hasOwnProperty('genres')) {
          let genres: any = filter.genres;
          finalFilterArray = finalFilterArray.filter((item: any) => genres.includes(item.genre));
         }
         if (filter.hasOwnProperty('keys')) {
          let keys: any = filter.keys;
          finalFilterArray = finalFilterArray.filter((item: any) => keys.includes(item.key));
         }
         if (filter.hasOwnProperty('instruments')) {
          let instrumentsList: any = filter.instruments;
          finalFilterArray = finalFilterArray.filter((item: any) => {
            let instrumentData = item.instrument;
            if (instrumentData && instrumentData.length > 0) {
              let filterList: any  = instrumentData.filter((instructionObj: any) => instrumentsList.includes(instructionObj))
              if (filterList &&  filterList.length > 0) {
                return item;
              }
            }
          });
         }
      } else {
        finalFilterArray = array;
      }
    } else {
      if (!section) {
        finalFilterArray = array;
      } else {
        if (array.length > 0 && type) {
          let filterData: any =  array.filter(item => item[applyFilterKey] === type);
          finalFilterArray = filterData.length > 0 ? filterData : [];
        }
      }
    }
   
   
    return finalFilterArray;
  }
}
